export default {
    namespaced: true,
    alarm_groups: {
      title: "Grupo de alarmes | Grupo de alarme",
      name: 'Nombre',
      group: 'Grupo',
      select: 'Selecione um ou mais grupos'
    },
};
